var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"unsubscribe"},[_c('div',{staticClass:"side-image u-bgcolor"}),_c('div',{staticClass:"unsubscribe-content"},[_c('p',{staticClass:"unsubscribe-content-message u-bfbgcolor u-bgcolor-pseudo"},[_vm._v("You have been unsubscribed.")])])])
}]

export { render, staticRenderFns }